(function() {
    'use strict';

    angular
        .module('app')
        .directive('autocompleteFocus', autocompleteFocus);

    autocompleteFocus.$inject = ['$timeout'];
    
    function autocompleteFocus($timeout) {
        // Usage:
        //     <autocompleteBlur></autocompleteBlur>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                inputId: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            $timeout(getDataOnBlur, 0);

            function getDataOnBlur() {
                element.find("#".concat(inputid)).bind("blur", function () {
                    angular.element(this).val('getting data');
                });
            }


        }
    }

})();